import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/api/axios-instance";

export interface Company {
  id: string;
  name: string;
  domain: string;
  status: "ACTIVE" | "INACTIVE";
}

export async function getCompanies(): Promise<Company[]> {
  const r = await axiosInstance.get("/company");
  return r.data ?? [];
}

export function useCompanies() {
  return useQuery({
    queryKey: ["companies"],
    queryFn: getCompanies,
  });
}
